import FormulateVuePhone from '../phone/FormulateVuePhone';

export default function FormulateVuePhonePlugin(formulateInstance) {
  formulateInstance.extend({
    components: {
      FormulateVuePhone,
    },
    library: {
      phone: {
        classification: 'text',
        component: 'FormulateVuePhone',
      },
    },
    rules: {
      phoneIsValid: ({ getFormValues }) => {
        const { phone } = getFormValues();
        const regex = /[a-zA-Z]+/g;

        return !!phone && (phone.isValid == null || phone.isValid) && !regex.test(phone?.phone ?? '');
      },
    },
  });
}
